<template>
  <section class="dd-l-section dd-l-section--products-search">
    <div
      class="dd-l-container__wrapper dd-l-container__wrapper--content dd-l-container__wrapper--grid"
    >
      <!-- Has Result -->
      <h2 class="dd-l-section--products-search__title">{{title}}</h2>
		<hr>
      <div class="dd-m-filter" v-if="false">
        <div class="dd-l-container__wrapper dd-l-container__wrapper--content">
          <div class="dd-m-filter__grids">
            <div class="dd-m-filter__row dd-m-filter__row--category">
              <categories-filter></categories-filter>
            </div>

            <div class="dd-m-filter__row dd-m-filter__row--tiny">
              <sort-filter></sort-filter>
              <attributes-filter></attributes-filter>
            </div>
          </div>
        </div>
      </div>

      <category-products-content v-if="cat" :per-page="perPage" :slug="cat" :cat-name="catName"></category-products-content>
    </div>
  </section>
</template>
<script>
import CategoriesFilter from "../filters/categories-filter";
import SortFilter from "../filters/sort-filter";
import CategoryProductsContent from "./category-products-content";
import AttributesFilter from "../filters/attributes-filter";

export default {
  name: "list-category-products",
  components: {
    AttributesFilter,
    CategoryProductsContent,
    SortFilter,
    CategoriesFilter
  },
  props: ["perPage", "cat", "title", "catName"],
  data: () => {
    return {
      results: []
    };
  },
  mounted() {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// resources/site/js/components/products/list-category-products.vue